import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';

export const WrapperSt = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-bottom: 1rem;
`;

export const NonGutterAbsolutElementSt = styled.div`
  position: absolute;
  width: calc(100% + 2rem);
  margin-right: -1rem;
  margin-left: -1rem;
  ${media.sm(css`
    width: calc(100% + 4rem);
    margin-right: -2rem;
    margin-left: -2rem;
  `)};
  ${media.lg(css`
    width: calc(100% + 8rem);
    margin-right: -4rem;
    margin-left: -4rem;
  `)}
`;

interface IStyledUlWrapperStProps {
  icon: string;
}

export const StyledUlWrapperSt = styled.div<IStyledUlWrapperStProps>`
  ul {
    list-style: none;

    > li {
      position: relative;
      margin: 0.5rem 0;
    }

    > li:before {
      content: '';
      background: url(${({ icon }) => icon}) no-repeat;
      width: 24px;
      height: 24px;
      left: -2.5rem;
      position: absolute;
      top: 0.25rem;
    }
  }
`;
